import React from 'react';
import { useTranslation } from 'react-i18next';
import { Warehouse } from '../../types/entities';

interface WarehouseInfoCardProps {
  warehouse: Warehouse;
  inventoryCount: number;
}

export const WarehouseInfoCard: React.FC<WarehouseInfoCardProps> = ({
  warehouse,
  inventoryCount,
}) => {
  const { t } = useTranslation();

  return (
    <div className="card">
      <h2 className="text-lg font-semibold mb-4">{t('warehouses.info')}</h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div>
          <label className="text-sm text-gray-500">{t('warehouses.address')}</label>
          <p className="font-medium">{warehouse.address || '-'}</p>
        </div>
        <div>
          <label className="text-sm text-gray-500">{t('warehouses.contact')}</label>
          <p className="font-medium">
            {warehouse.contactPerson || '-'}
            {warehouse.contactPhone && (
              <span className="text-gray-500 ml-2">({warehouse.contactPhone})</span>
            )}
          </p>
        </div>
        <div>
          <label className="text-sm text-gray-500">{t('common.status')}</label>
          <p>
            <span
              className={`px-2 py-1 rounded text-sm ${
                warehouse.status === 'ACTIVE'
                  ? 'bg-green-100 text-green-700'
                  : 'bg-gray-100 text-gray-700'
              }`}
            >
              {warehouse.status === 'ACTIVE' ? t('common.active') : t('common.inactive')}
            </span>
          </p>
        </div>
        <div>
          <label className="text-sm text-gray-500">{t('warehouses.totalItems')}</label>
          <p className="font-medium">{inventoryCount}</p>
        </div>
      </div>
    </div>
  );
};
